import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DataSource } from '@europrocurement/l2d-redux-utils';
import {
    FormaliteDocument,
    formalitiesDocumentSelector,
    FormalityAppDispatch,
    useFormaliteService,
} from '@europrocurement/l2d-domain';

type UseDocumentTypeProps = {
    documentTypeId: string | undefined;
};

const useDocumentType = (props: UseDocumentTypeProps) => {
    const { selectFormaliteDocument } = useFormaliteService();

    const { documentTypeId } = props;
    const documentTypeDataSource: DataSource<FormaliteDocument> = useSelector(
        formalitiesDocumentSelector,
    );
    const dispatch = useDispatch<FormalityAppDispatch>();

    useEffect(() => {
        if (documentTypeId) {
            dispatch(selectFormaliteDocument({ id: documentTypeId }));
        }
    }, [dispatch, documentTypeId, selectFormaliteDocument]);

    const documentType = useMemo(
        () => documentTypeDataSource.selected,
        [documentTypeDataSource.selected],
    );

    return {
        documentType,
        requestState: documentTypeDataSource.selectedStatus,
    };
};

export default useDocumentType;
